import React from 'react'
import { Row, Col,Typography } from 'antd';
import CourseData from './CourseData'
import './courses.css'


const { Title, Text } = Typography;

function Courses() {
    return (
        <div className="couse-home-cn">
        <div className="courses-container" id="courses">
            <div className="edusol-heading-container">
                <Text className="paragraph">
                    <p>
                        Best Courses
                    </p>
                </Text>
                <Title className="sectionHeading-edusol">Available Programs</Title>
            </div>
            
            <Row justify="center" gutter={[{ xs: 8, sm: 16, md: 24, lg: 32, xl: 16 }, 30]} >
                {CourseData.map(course =>
                    <Col className="" xs={22} sm={11} md={11} lg={11} xl={6}>
                       
                            <div class="grid">
                                <div class="grid__item">
                                    <div class="card">
                                        <img class="card__img" src={course.img} />
                                        <div class="card__content">
                                            <h1 class="card__header">{course.title}</h1>
                                            <p class="card__text">{course.description}</p>
                                            <button class="card__btn">Explore <span>&rarr;</span></button></div>
                                    </div>
                                </div>
                            </div>
                           
                    </Col>
                )}
            </Row>
            </div>
        </div>
    )
}

export default Courses;